<template>
  <header class="hdr" :class="{ 'hdr--solid': solid, 'hdr--hidden': hidden && !open, 'hdr--instant': instant }">
    <div class="hdr__bar">
      <router-link :to="'/' + site" class="hdr__logo" :aria-label="info.name + ' ' + info.place">
        <SiteLogo :site="site" />
      </router-link>

      <nav class="hdr__nav" aria-label="Основное меню">
        <div v-for="item in menu" :key="item.name" class="hdr__item">
          <router-link :to="'/' + site + item.link" class="hdr__link">{{ item.name }}</router-link>
          <div v-if="item.child && item.child.length" class="hdr__drop">
            <router-link v-for="child in item.child" :key="child.link" :to="'/' + site + child.link" class="hdr__drop-link">{{ child.name }}</router-link>
          </div>
        </div>
      </nav>

      <div class="hdr__right">
        <router-link v-if="other" :to="'/' + other.key" class="hdr__switch">{{ other.place }}</router-link>
        <a :href="'tel:' + info.tel" class="hdr__phone">{{ info.phone }}</a>
        <router-link :to="'/' + site + '/booking/'" class="t-btn hdr__book">Забронировать</router-link>
        <button type="button" class="hdr__burger" :class="{ 'is-open': open }" aria-label="Меню" @click="open = !open">
          <span></span><span></span>
        </button>
      </div>
    </div>

    <transition name="hdr-fade">
      <div v-if="open" class="hdr__panel">
        <div v-for="item in menu" :key="item.name" class="hdr__panel-group">
          <router-link :to="'/' + site + item.link" class="hdr__panel-title">{{ item.name }}</router-link>
          <router-link v-for="child in (item.child || [])" :key="child.link" :to="'/' + site + child.link" class="hdr__panel-link">{{ child.name }}</router-link>
        </div>
        <div class="hdr__panel-foot">
          <a :href="'tel:' + info.tel" class="hdr__panel-phone">{{ info.phone }}</a>
          <router-link :to="'/' + site + '/booking/'" class="t-btn">Забронировать</router-link>
          <router-link v-if="other" :to="'/' + other.key" class="hdr__panel-other">Перейти: {{ info.name }} {{ other.place }}</router-link>
        </div>
      </div>
    </transition>
  </header>
</template>

<script>
import { SITES, MENUS, siteInfo } from '../config/sites'
import { getVisibleMenu } from '../utils/photos'
import SiteLogo from './SiteLogo'

export default {
  name: 'Header',
  components: { SiteLogo },
  data () {
    return {
      open: false,
      instant: false,
      scrolled: false,
      hidden: false,
      lastY: 0,
      availableMenu: [],
      menuLoaded: false
    }
  },
  computed: {
    site () {
      return this.$root.site === 'picunda' ? 'pitsunda' : this.$root.site
    },
    info () {
      return siteInfo(this.site)
    },
    other () {
      if (this.site === 'amari') return null
      return this.site === 'abaata' ? SITES.pitsunda : SITES.abaata
    },
    menu () {
      return this.menuLoaded ? this.availableMenu : (MENUS[this.site] || MENUS.abaata)
    },
    isHome () {
      return this.$route.name === 'Abaata'
    },
    solid () {
      return !this.isHome || this.scrolled || this.open
    }
  },
  watch: {
    $route () {
      this.open = false
      this.hidden = false
      // при смене страницы шапка переключается без анимации, чтобы не мелькало смешанное состояние
      this.instant = true
      this.$nextTick(this.onScroll)
      this.loadMenu()
      setTimeout(() => { this.instant = false }, 150)
    },
    open (value) {
      document.body.style.overflow = value ? 'hidden' : ''
    }
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll, { passive: true })
    this.onScroll()
    this.loadMenu()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
    document.body.style.overflow = ''
  },
  methods: {
    onScroll () {
      const y = window.pageYOffset
      this.scrolled = y > 40
      this.hidden = y > 160 && y > this.lastY
      this.lastY = y
    },
    loadMenu () {
      const site = this.site
      this.menuLoaded = false
      getVisibleMenu(site).then(menu => {
        if (this.site !== site) return
        this.availableMenu = menu
        this.menuLoaded = true
      })
    }
  }
}
</script>

<style scoped lang="scss">
.hdr {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  color: #fff;
  transition: transform .3s ease, background .3s ease, color .3s ease, box-shadow .3s ease;

  &--solid {
    background: var(--bg);
    color: var(--fg);
    box-shadow: 0 1px 0 var(--line);
  }
  &--hidden { transform: translateY(-100%); }
  &--instant { transition: none; }
}
.hdr__bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  width: calc(100% - var(--pad) - var(--pad));
  max-width: var(--content-width, 1440px);
  height: 72px;
  margin: 0 auto;
  padding: 0;
}
.hdr__logo {
  display: flex;
  flex-direction: column;
  line-height: 1;
  color: inherit !important;
  flex-shrink: 0;
}
.hdr__nav {
  display: flex;
  gap: 4px;
  margin: 0 auto;
}
.hdr__item { position: relative; }
.hdr__link {
  display: block;
  padding: 26px 14px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: .1em;
  text-transform: uppercase;
  color: inherit !important;
  white-space: nowrap;
}
.hdr__link:hover, .hdr__link.router-link-active { color: var(--acc) !important; }
.hdr--solid .hdr__link.router-link-exact-active { color: var(--acc) !important; }
.hdr__drop {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 240px;
  padding: 10px 0;
  background: var(--bg);
  color: var(--fg);
  border: 1px solid var(--line);
  border-radius: var(--r);
  box-shadow: 0 18px 40px rgba(0, 0, 0, .14);
  opacity: 0;
  visibility: hidden;
  transform: translateY(6px);
  transition: all .2s ease;
}
.hdr__item:hover .hdr__drop { opacity: 1; visibility: visible; transform: none; }
.hdr__drop-link {
  display: block;
  padding: 10px 20px;
  font-size: 15px;
  color: var(--fg) !important;
}
.hdr__drop-link:hover { background: rgba(0, 0, 0, .04); color: var(--acc) !important; }
.hdr__right {
  display: flex;
  align-items: center;
  gap: 18px;
  flex-shrink: 0;
}
.hdr__switch {
  font-size: 12px;
  letter-spacing: .14em;
  text-transform: uppercase;
  color: inherit !important;
  opacity: .8;
  border-bottom: 1px solid currentColor;
}
.hdr__phone {
  font-size: 15px;
  font-weight: 700;
  color: inherit !important;
  white-space: nowrap;
}
.hdr__book { padding: 12px 20px; font-size: 12px; color: var(--on-acc) !important; }
.hdr__burger {
  display: none;
  position: relative;
  width: 32px;
  height: 32px;
  background: none;
  border: 0;
  color: inherit;
  span {
    position: absolute;
    left: 4px;
    right: 4px;
    height: 2px;
    background: currentColor;
    transition: transform .25s ease, top .25s ease;
  }
  span:nth-child(1) { top: 11px; }
  span:nth-child(2) { top: 19px; }
  &.is-open span:nth-child(1) { top: 15px; transform: rotate(45deg); }
  &.is-open span:nth-child(2) { top: 15px; transform: rotate(-45deg); }
}

.hdr__panel {
  position: fixed;
  top: 72px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  padding: 10px var(--pad) 110px;
  background: var(--bg);
  color: var(--fg);
}
.hdr__panel-group { padding: 14px 0; border-bottom: 1px solid var(--line); }
.hdr__panel-title {
  display: block;
  font-family: var(--head);
  font-size: 24px;
  color: var(--fg) !important;
}
.hdr__panel-link {
  display: block;
  padding: 8px 0 0 2px;
  font-size: 16px;
  color: var(--mut) !important;
}
.hdr__panel-foot { padding-top: 24px; display: flex; flex-direction: column; gap: 16px; align-items: flex-start; }
.hdr__panel-phone { font-size: 22px; font-weight: 700; color: var(--fg) !important; }
.hdr__panel-other { font-size: 14px; color: var(--acc) !important; border-bottom: 1px solid currentColor; }
.hdr-fade-enter-active, .hdr-fade-leave-active { transition: opacity .2s ease; }
.hdr-fade-enter, .hdr-fade-leave-to { opacity: 0; }

@media (max-width: 1180px) {
  .hdr__phone { display: none; }
}
@media (max-width: 980px) {
  .hdr__nav, .hdr__switch, .hdr__book { display: none; }
  .hdr__burger { display: block; }
  .hdr__bar { height: 64px; }
  .hdr__panel { top: 64px; }
}
</style>
